// AUTO-GENERATED by `npm run codegen:ui` - do not edit.
namespace $ {

export type easyreels_user_recorder_startMutationVariables = Exact<{ [key: string]: never; }>;


export type easyreels_user_recorder_startMutation = { __typename?: 'Mutation', startRecording: { __typename: 'ErrorPayload', message: string } | { __typename: 'QuotaExceededPayload', message: string, usedBytes: number, limitBytes: number } | { __typename: 'StartRecordingPayload', recording: { __typename?: 'Recording', id: number }, tickets: Array<{ __typename?: 'UploadTicket', sequence: number, url: string, fields: Array<{ __typename?: 'FormField', name: string, value: string }>, expiresAt: { __typename?: 'Timestamp', unix: number } }> } };


export function $easyreels_user_recorder_start(opts?: { revalidate?: boolean }): easyreels_user_recorder_startMutation {
	return $easyreels_gql_user_request(`mutation easyreels_user_recorder_start {
  startRecording {
    __typename
    ... on StartRecordingPayload {
      recording {
        id
      }
      tickets {
        sequence
        url
        fields {
          name
          value
        }
        expiresAt {
          unix
        }
      }
    }
    ... on QuotaExceededPayload {
      message
      usedBytes
      limitBytes
    }
    ... on ErrorPayload {
      message
    }
  }
}`, undefined, opts) as easyreels_user_recorder_startMutation
}

}
